import {
  FormData,
  PersonalInfoWithId,
  RefereeInfo
} from '../../../types/forms';

export const handlePersonalInfoChange = (
  formData: FormData, 
  setFormData: React.Dispatch<React.SetStateAction<FormData>>,
  data: PersonalInfoWithId
) => {
  setFormData(prev => ({
    ...prev,
    personal: data
  }));
};

export const handleCounsellingInfoChange = (
  formData: FormData, 
  setFormData: React.Dispatch<React.SetStateAction<FormData>>,
  field: string, 
  value: any
) => {
  setFormData(prev => ({
    ...prev,
    counselling: {
      ...prev.counselling,
      [field]: value
    }
  }));
};

export const handleEducationInfoChange = (
  formData: FormData, 
  setFormData: React.Dispatch<React.SetStateAction<FormData>>,
  field: string, 
  value: any
) => {
  setFormData(prev => ({
    ...prev,
    education: {
      ...prev.education,
      [field]: value
    }
  }));
};

export const handleRefereeInfoChange = (
  formData: FormData, 
  setFormData: React.Dispatch<React.SetStateAction<FormData>>,
  data: RefereeInfo
) => {
  setFormData(prev => ({
    ...prev,
    referee: data
  }));
};

export const handleSaveSection = async (
  section: string,
  formData: FormData,
  token: string | undefined,
  setSaveStatus: React.Dispatch<React.SetStateAction<{ [key: string]: 'idle' | 'saving' | 'saved' | 'error' }>>,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
  validateSectionForSave: (section: string, field: string, value: any) => string,
  api: any
) => {
  try {
    setSaveStatus(prev => ({ ...prev, [section]: 'saving' }));
    
    // For save progress, only validate fields that have values
    const sectionData = formData[section as keyof FormData];
    let hasValidationError = false;

    // Check each field in the section that has a value
    Object.entries(sectionData as any).forEach(([field, value]) => {
      const error = validateSectionForSave(section, field, value);
      if (error) {
        setError(error);
        hasValidationError = true;
        return;
      }
    });

    if (hasValidationError) {
      setSaveStatus(prev => ({ ...prev, [section]: 'error' }));
      return;
    }

    const url = `/api/counsellors/public/application/${token}/${section}`;
    console.log(`Saving ${section} to URL:`, url);
    
    const response = await api.put(url, sectionData);
    
    if (response.status === 200) {
      console.log(`${section} saved successfully:`, response.data);
      setSaveStatus(prev => ({ ...prev, [section]: 'saved' }));
      setError(null);
    }
  } catch (err: any) {
    console.error(`Error saving ${section}:`, err);
    setSaveStatus(prev => ({ ...prev, [section]: 'error' }));
    setError(err.response?.data?.error || `Error saving ${section}`);
  }
};
